export default "<div id=\"hc-gauge\"></div>\n";